import { render, staticRenderFns } from "./RequestFields.vue?vue&type=template&id=fcb07040&"
import script from "./RequestFields.vue?vue&type=script&lang=js&"
export * from "./RequestFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports